import {createAction, props} from '@ngrx/store';

export const setLanguages = createAction('[Language Component] Set Language', props<{ language: string }>() );
